// @flow

import { isMaxLength, isMinLength } from "../String";
import { isNumber } from "../Number";

export function isGermanAccountNumber(value?: ?string) {
  return isMinLength(1)(value) && isMaxLength(10)(value) && isNumber(value);
}
